import {useState} from 'react'
import axios from 'axios'
import {useNavigate} from "react-router-dom";
import {useCookies} from 'react-cookie'
import config from "../config";

const AuthModal = ({setShowModal, isSignUp, addAuthToken}) => {
    const [email,setEmail] =useState(null)
    const [password,setPassword] = useState(null)
    const [confirmPassword, setConfirmPassword] = useState(null)
    const [error, setError] = useState(null)
    const [, setCookie] = useCookies(['user'])

    let navigate = useNavigate()
    const handleClick = () =>{
        setShowModal(false)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        try{
            if (isSignUp && (password !== confirmPassword)){
                setError('Passwörter müssen übereinstimmen')
                return
            }

            const response = await axios.post(`${config.apiUrl}${isSignUp ? 'signup':'login'}`,{email,password})
            localStorage.setItem("token", response.data.token);

            if (response.status === 201 && isSignUp) {
                setCookie("UserId",response.data.userId);
                navigate('/onboarding/0');
            }
            if (response.status === 200 && !isSignUp){
                setCookie("UserId",response.data.userId);
                navigate('/dashboard');
            }

        } catch(error){
            if (error.response) {
                console.log("Error data:", error.response.data)
                console.log("Error status:", error.response.status)
                setError(error.response.data.message)
            }
            else if (error.request){
                console.log("No response received:", error.request)
            }
            else{
                console.log("Error:", error.message)
            }
        }

    }

    return(
        <div className="auth-modal">
            <h2>{isSignUp?'Konto erstellen':'Einloggen'}</h2>
            <form onSubmit={handleSubmit}>

                <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="E-Mail"
                    required={true}
                    onChange={(e)=>setEmail(e.target.value)}
                />
                <input
                    type="password"
                    id="password"
                    name="password"
                    placeholder="Passwort"
                    required={true}
                    onChange={(e)=>setPassword(e.target.value)}
                />
                {isSignUp && <input
                    type="password"
                    id="confirm-password"
                    name="confirm-password"
                    placeholder="Passwort bestätigen"
                    required={true}
                    onChange={(e)=>setConfirmPassword(e.target.value)}
                />}
                <p>{error}</p>
                <button className="secondary-button" type="submit">Absenden</button>

            </form>
            <hr/>
        </div>
    )
}
export default AuthModal